import { z } from "zod";
export const slackInstallationStatusSchema = z.enum(["active", "revoked"]);
export const slackInstallationSchema = z.object({
    teamId: z.string(),
    teamName: z.string().nullable(),
    status: slackInstallationStatusSchema,
    revokedAt: z.coerce.date().nullable(),
    revokedReason: z.string().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const slackInstallationsResponseSchema = z.object({
    installations: z.array(slackInstallationSchema),
});
export const disconnectSlackInstallationResponseSchema = z.object({
    teamId: z.string(),
    disconnected: z.boolean(),
});
